import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import LandingPage from './components/LandingPage'


function App() {
    return (
        <LandingPage />
        // <Router>
        //     <Switch>
        //         <Route exact path={'/'} component={LandingPage} />
        //         {/* <Route path={'/'} name="Index" render={(props) => <LandingPage {...props} />}></Route> */}

        //     </Switch>
        // </Router>
    )
}

export default App